// import DatePickerLocale from 'rmc-date-picker/lib/locale/en_US';

export default {
  okText: 'ÐÐº',
  dismissText: 'ÐÑÐ¼ÐµÐ½Ð°',
  extra: '',
  // DatePickerLocale,
  year: '',
  month: '',
  day: '',
  hour: '',
  minute: '',
  am: 'AM',
  pm: 'PM'
};